import React, { Component, Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import DataReactTable from './DataReactTable';
import Modal from '@material-ui/core/Modal';
import ReactTableActions from './ReactTableActions'
import ReactTableActionsDiagnostic from './ReactTableActionsDiagnostic';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SearchModalCIE10 from '../../../../SearchModals/CIE10/SearchModalCIE10';
import SearchModalCIE10Table from '../../../../SearchModals/CIE10/SearchModalCIE10Table';
import SearchModalCIe10TableActions from '../../../../SearchModals/CIE10/SearchModalCIe10TableActions';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const Header = ({ column }) => (
  <span className="react-table__column-header">
    <span>
      {column}
    </span>
  </span>
);

class Diagnostic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      code: '',
      dataOldDiagnostic: [],
      dataDiagnostic: [],
      addedDiagnostics: [],
      observations: [],
      openModal: false,
      loadAddedDiagnostics: false,
      load: false,
    };
  }

  /*
    componentDidMount() {
      this.setState({ load: true }, ()=>{
        this.props.loadDiagnostic().then((load) => {
          this.setState({ load: load },()=>{
              console.log("cargar terminada !!");
          });
        }).catch((error)=>{
          console.log(error)
        });
      })    
    }*/

  loadDiagnostics = () => {
    var data = { id_historia: this.props.id_historia }
    fetch(process.env.REACT_APP_PUBLIC_URL + 'diagadmision/consultar', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        console.log(data);
        console.log("cargar diagnostico");
        if (data.existe) {
          console.log(data.contenido);
          this.setState({ dataOldDiagnostic: data.contenido.diagnostico.diagnostico })
          //this.dataOldDiagnostic()
        } else {

        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  render() {
    const reactTableDataOldDiagnostic = {
      tableHeaderData: [{
        Header: 'CIE 10',
        accessor: 'codigo',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'DESCRIPCIÓN',
        accessor: 'nombre',
      },
      {
        Header: 'TIPO',
        accessor: 'tipo'
      },
      {
        Header: 'OBSERVACIÓN',
        accessor: 'observacion',
      }
      ],
      tableRowsData: this.props.Diagnostic.dataOldDiagnostic
    };


    const reactTableFoundDiagnostics = {
      tableHeaderData: [{
        Header: 'CIE 10',
        accessor: 'codigo',
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: 'DESCRIPCIÓN',
        accessor: 'nombre',
      }
      ],
      tableRowsData: this.state.dataDiagnostic
    }

    const LoadTableOldDiagnostic = () => {
      return (
        <DataReactTable
          title="Diagnosticos Anteriores"
          reactTableData={reactTableDataOldDiagnostic}
          config={{
            withPagination: true,
            withSearchEngine: false,
            isSortable: false,
            watchCustomMenu: false
          }}
          ReactTableActions={ReactTableActions}
          Callback={() => {
            var data = this.state.dataOldDiagnostic;
            data.pop();
            this.setState({ dataOldDiagnostic: data })
          }
          }
          AddObservation={this.props.addObservation}
        />
      )
    }

    return (
      <Fragment>
        <Col md={12} sm={12}>
          <div className={"container-wraper-hc"}>
            {!this.props.Diagnostic.load ?
              <>
                <div style={{ flex: 1, flexDirection: 'column' }}>
                  <div className="title-clinic-history">
                    <h4>Diagnóstico</h4>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div>
                      <span className="form__form-group-label" style={{ margin: 'auto', paddingRight: 10 }} > Buscar Diagnóstico</span>
                    </div>
                    <div>
                      <Tooltip
                        title="Buscar"
                      >
                        <IconButton
                          aria-label="upload picture"
                          component="span"
                          className='tooltip-top'
                          color="primary"
                          disabled={this.props.stateClinicHistory}
                          style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                          onClick={() => {
                            this.setState({ openModal: !this.state.openModal });
                          }}
                        >
                          <span className="lnr lnr-magnifier" style={{ fontSize: 20, color: '#153365' }} />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="table-medicine-add">
                    <table className="table table--bordered" >
                      <thead>
                        <tr className="react-table thead tr">
                          <th>
                            <Header column="CIE 10" />
                          </th>
                          <th>
                            <Header column="DESCRIPCIÓN" />
                          </th>
                          <th>
                            <Header column="TIPO DIAGNÓTICO PRINCIPAL" />
                          </th>
                          <th>
                            <Header column="OBSERVACIÓN" />
                          </th>
                          <th>
                            <Header column="ACCIÓN" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.Diagnostic.addedDiagnostics.map((diagnostic, index) => {
                          /* let observationCurrentDiag = diagnostic.hasOwnProperty('observacion') ? diagnostic.observacion : '';
                          if (!!observationCurrentDiag) {
                            let oldObservations = this.state.observations;
                            oldObservations[index] = observationCurrentDiag;
                            this.setState({ observations: oldObservations })
                          } */
                          return <tr key={index}>
                            <td>{diagnostic.codigo}</td>
                            <td>{diagnostic.nombre}</td>
                            <td>
                              <TextField
                                label=""
                                disabled={this.props.stateClinicHistory}
                                value={this.props.Diagnostic.typesDiag[index]}
                                onChange={(event) => {
                                  this.props.handlerAddTypeDiagnostic(index, event.target.value);
                                }}
                                select
                                style={{ minWidth: '80%', maxWidth: '80%', marginLeft: '0.25em' }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                  style: { color: '#646777' }
                                }}
                              >
                                <MenuItem key={0} value={'NO APLICA'}>NO APLICA</MenuItem>
                                <MenuItem key={1} value={'IMPRESIÓN DIAGNÓSTICA'}>IMPRESIÓN DIAGNÓSTICA</MenuItem>
                                <MenuItem key={2} value={'CONFIRMADO NUEVO'}>CONFIRMADO NUEVO</MenuItem>
                                <MenuItem key={3} value={'CONFIRMADO REPETIDO'}>CONFIRMADO REPETIDO</MenuItem>
                              </TextField>
                            </td>
                            <td style={{ marginLeft: 10 }}>
                              {/* <input
                          name={`observation-${index}`}
                          type="text"
                          value={this.state.observations[index]}
                          onChange={(e) => {
                            var observations = this.state.observations;
                            observations[index] = e.target.value;
                            this.setState({ observations: observations });
                            this.props.addObservation(index, e.target.value);
                          }}
                        /> */}
                              <TextField
                                label=""
                                disabled={this.props.stateClinicHistory}
                                value={this.props.Diagnostic.observations[index]}
                                style={{ marginLeft: '0.25em' }}
                                onChange={(e) => {
                                  var observations = this.state.observations;
                                  observations[index] = e.target.value;
                                  this.setState({ observations: observations });
                                  this.props.addObservation(index, e.target.value);
                                }}
                                className="medical-material-form__field"
                                InputLabelProps={{
                                  //style: { color: '#646777' }
                                }}
                              />
                            </td>

                            <td style={{ marginLeft: 10 }}>
                              <Tooltip
                                title="Quitar"
                              >
                                <IconButton
                                  aria-label="upload picture"
                                  component="span"
                                  className='tooltip-top'
                                  disabled={this.props.stateClinicHistory}
                                  onClick={() => {
                                    var data = this.props.Diagnostic.addedDiagnostics;
                                    data = data.filter((value, indexDiag) => {
                                      return indexDiag !== index;
                                    });
                                    var observations = this.state.observations;
                                    observations = observations.filter((value, indexDiag) => {
                                      return indexDiag !== index;
                                    });
                                    console.log(data);
                                    console.log(index);
                                    this.setState({ addedDiagnostics: data, observations: observations, countDiagnostic: this.state.countDiagnostic - 1 }, () => {
                                      this.props.removeDiagnostic(index);
                                    })
                                  }}
                                >
                                  <DeleteForeverIcon style={{ color: '#153365' }} />
                                </IconButton>
                              </Tooltip>
                            </td>
                          </tr>
                        })}
                      </tbody>
                    </table>
                  </div>
                  <Row style={{margin: '2em 0em'}}>
                  <span className='common-label-section-others'>Observacion general del Diagnóstico</span>
                    <TextField
                      type="text"
                      style={{margin: '0.5em 0.25em'}}
                      className="material-form__field"
                      value={this.props.Diagnostic.generalObservation}
                      disabled={this.props.stateClinicHistory}
                      onChange={(e) => {
                        this.props.handlerDiagnosticGeneralObervation(e.target.value);
                      }}
                    />
                  </Row>
                  <div className="title-clinic-history" style={{ margin: '3em 0em 0em 0em' }}>
                    <h4>Diagnósticos Anteriores</h4>
                  </div>
                  <div className="table-medicine-add" /* style={{ marginTop: 50, marginBottom: 50 }} */>
                    <LoadTableOldDiagnostic />
                  </div>
                </div>

                <SearchModalCIE10
                  openModalCIE10={this.state.openModal}
                  closeModalCIE10={() => {
                    this.setState({ openModal: false });
                  }}
                  Callback={(diagnostic) => {
                    var diagnosticNew = diagnostic;
                    this.setState({ loadAddedDiagnostics: true }, () => {
                      var addedDiagnostics = this.props.Diagnostic.addedDiagnostics;
                      if (!addedDiagnostics.includes(diagnosticNew)) {
                        //addedDiagnostics.push(diagnosticNew);
                        //this.props.selectDiagnostic(diagnostic);
                        this.props.addDiagnostic(diagnosticNew);
                        this.setState({ code: "", name: "" });
                      } else {
                        alert("Ya se incluyo este diagnostico");
                      }
                      this.setState({ addedDiagnostics: addedDiagnostics, observations: [...this.state.observations, ""], loadAddedDiagnostics: false, countDiagnostic: this.state.countDiagnostic + 1 });
                    });
                  }}
                />

              </>
              : null}
          </div>
        </Col>
      </Fragment>
    );
  }
}

export default reduxForm({
  form: `diagnostic-form`, // a unique identifier for this form
})(withTranslation('common')(Diagnostic));